import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as ListBranchActionMetadataKeys from 'automation-ui-action-features/actions/list-branch/constants/ListBranchActionMetadataKeys';
export default class ListBranchActionMetadata extends Record({
  [ListBranchActionMetadataKeys.ACTION_TYPE]: ActionTypes.LIST_BRANCH
}, 'ListBranchActionMetadata') {}